import React from 'react';
import { formatCount, formatUsd } from '../../utils/format';
import { StoredReference } from '../sf/StoredReference';
interface CloseSummaryProps {
  storedTotal: number;
  adjustedTotal: number;
  payeeCount: number;
  loans: number;
  lines: number;
  adjustmentsPending: number;
  negativeComp: number;
  isLocked: boolean;
}
export function CloseSummary({
  storedTotal,
  adjustedTotal,
  payeeCount,
  loans,
  lines,
  adjustmentsPending,
  negativeComp,
  isLocked
}: CloseSummaryProps) {
  const stats = [{
    label: 'Payees',
    value: formatCount(payeeCount),
    tone: ''
  }, {
    label: 'Loans',
    value: formatCount(loans),
    tone: ''
  }, {
    label: 'Commission lines',
    value: formatCount(lines),
    tone: ''
  }, {
    label: 'Adjustments pending',
    value: formatCount(adjustmentsPending),
    tone: adjustmentsPending > 0 ? 'text-sf-amber-text' : ''
  }, {
    label: 'Negative comp',
    value: formatCount(negativeComp),
    tone: negativeComp > 0 ? 'text-sf-amber-text' : ''
  }];
  return <section aria-label="Period summary" className="grid grid-cols-1 overflow-hidden rounded border border-sf-border bg-white shadow-card lg:grid-cols-[420px_minmax(0,1fr)]" data-id="element-584" data-mp="3tqs3hhldhavz">
      <div className="border-b border-sf-border px-5 py-4 lg:border-b-0 lg:border-r" data-id="element-585" data-mp="2mjx4isgmrfp">
        <p className="text-xs font-semibold text-sf-weak" data-id="element-586" data-mp="3k0fixpdk5hpu">{isLocked ? 'Final payout' : 'Total payout'} · October 2026</p>
        <p className="mt-2 text-[11px] text-sf-weak" data-id="element-587" data-mp="3oxp7l2t4hpcm">Adjusted · Adjusted Loan Amount × BPS — pays</p>
        <p className="mt-1 text-[32px] font-bold leading-none tabular-nums" data-id="element-588" data-mp="3b2n6csz80o65">{formatUsd(adjustedTotal)}</p>
        <p className="mt-2" data-id="element-589" data-mp="3fx0wafv4633f">
          <StoredReference value={storedTotal} data-id="element-590" data-mp="312w9wlr3nz3f" />
        </p>
        <p className="mt-2 text-xs text-sf-weak" data-id="element-591" data-mp="314h4gbdezi1a">Includes TL / Director rows (rates from the employee record).</p>
      </div>
      <dl className="grid grid-cols-2 sm:grid-cols-5" data-id="element-592" data-mp="zazpemmyfewi">
        {stats.map((stat, index) => <div key={stat.label} className={`flex flex-col justify-center px-5 py-4 ${index > 0 ? 'sm:border-l sm:border-sf-border' : ''}`} data-id="element-593" data-mp="149knafeqhmhs" data-mpi={index}>
            <dt className="whitespace-nowrap text-xs text-sf-weak" data-id="element-594" data-mp="12tgmfdraksl2">{stat.label}</dt>
            <dd className={`mt-0.5 text-2xl font-semibold tabular-nums ${stat.tone}`} data-id="element-595" data-mp="xsj6z8xo2cn9">{stat.value}</dd>
          </div>)}
      </dl>
    </section>;
}